import { Switch } from "@mui/material";
import axios from "axios";
import Select from "react-dropdown-select";
import TouchUpdateInputField from "../../component/TouchUpdateInputField";
import { GeographyDropdownValues, MatchDropdownValues } from "../../constants";

const REDBACKGROUND = ' bg-red-300 '

const SimilarProductsTabular = ({ imageData, mediaId, category, brands, getImageData, getBrands, type = 'social' }) => {


  const createNew = () => {
    axios.post(`/images-meta-api/similar-products/new-row`, { category, mediaId, type }).then(response => {
      getImageData()
    })
  }
  const deleteData = (id) => {
    axios.post(`/images-meta-api/similar-products/delete-data`, { category, mediaId, id, type }).then(response => {
      getImageData()
    })
  }

  const updateData = (id, field, value) => {
    axios.post(`/images-meta-api/similar-products/update-data`, { category, mediaId, id, field, value, type }).then(response => {
      if (field == 'brand' && value != null && !brands.includes(value))
        getBrands()
      getImageData()
    })
  }

  return <table className="border-collapse min-w-full table-auto mt-4 border border-slate-600 mb-10 pb-10 overflow-x-auto">
    <thead>
      <tr>
        {false ? <th>Id</th> : null}
        <th className="border border-slate-600 min-w-28">Preferred Design</th>
        <th className="border border-slate-600 min-w-28">Brand Name</th>
        <th className="border border-slate-600 max-w-48">Product Url</th>
        <th className="border border-slate-600 max-w-48">Image Url</th>
        <th className="border border-slate-600 min-w-28">Price</th>
        <th className="border border-slate-600 min-w-28">Count of Reviews</th>
        <th className="border border-slate-600 min-w-28">Match</th>
        <th className="border border-slate-600 min-w-28">Geography</th>
        <th className="border border-slate-600 min-w-28">DELETE</th>
      </tr>

    </thead>
    <tbody className="mb-10 pb-10">
      {
        imageData && imageData.SimilarProducts && imageData.SimilarProducts[category] ?
          imageData.SimilarProducts[category].map(tdata => <tr key={tdata.id} className='border-b w-full even:bg-slate-100'>
            {false ? <td>{tdata.id}</td> : null}

            <td className="border border-slate-600 p-1">
              <Switch
                checked={tdata.preferred == true}
                onChange={e => {
                  updateData(tdata.id, 'preferred', e.target.checked)
                }}
              />
            </td>
            <td className={`border border-slate-600 p-1 ${!tdata.brand ? REDBACKGROUND : ""}`} >
              <Select
                values={[{ value: tdata.brand || "" }]}
                labelField="value"
                options={brands.map(b => ({ value: b }))}
                placeholder="Select Brand"
                searchable={true}
                create={true}
                onChange={next => {
                  updateData(tdata.id, 'brand', next && next[0] ? next[0].value : null)
                }}
              />
            </td>
            <td className={`max-w-48 border border-slate-600 p-1 ${!tdata.productUrl ? REDBACKGROUND : ""}`} style={{ maxWidth: "12rem" }}>
              <TouchUpdateInputField
                value={tdata.productUrl}
                onChange={next => {
                  updateData(tdata.id, 'productUrl', next)
                }}
                textarea={true}
              />
              {tdata.productUrl ? <div className="flex justify-center"> <a href={tdata.productUrl} target='_blank' className="text-xs font-semibold text-blue-500 underline">LINK</a> </div> : null}
            </td>
            <td className={`max-w-48 border border-slate-600 p-1 ${!tdata.imageUrl ? REDBACKGROUND : ""}`} style={{ maxWidth: "12rem" }}>
              {tdata.imageUrl ? <div className="flex justify-center"><img src={tdata.imageUrl} className='w-40' /></div> : null}
              <TouchUpdateInputField
                value={tdata.imageUrl}
                onChange={next => {
                  updateData(tdata.id, 'imageUrl', next)
                }}
                textarea={true}
              />
              {tdata.imageUrl ? <div className="flex justify-center"> <a href={tdata.imageUrl} target='_blank' className="text-xs font-semibold text-blue-500 underline">LINK</a> </div> : null}
            </td>
            <td className={`border border-slate-600 p-1 ${!tdata.price ? REDBACKGROUND : ""}`} >
              <TouchUpdateInputField
                value={tdata.price}
                type="number"
                onChange={next => {
                  updateData(tdata.id, 'price', next)
                }}
              />
            </td>
            <td className={`border border-slate-600 p-1 ${!tdata.countOfReviews ? REDBACKGROUND : ""}`} >
              <TouchUpdateInputField
                value={tdata.countOfReviews}
                type="number"
                onChange={next => {
                  updateData(tdata.id, 'countOfReviews', next)
                }}
              />
            </td >
            <td className={`border border-slate-600 p-1 ${!tdata.match ? REDBACKGROUND : ""}`}>
              <select
                value={tdata.match || ""}
                onChange={(e => {
                  updateData(tdata.id, 'match', e.target.value)
                })}
                className='p-1 rounded '
              >
                <option value={""} disabled>Match</option>
                {MatchDropdownValues.map(v => <option value={v} >{v}</option>)}
              </select>
            </td>
            <td className={`border border-slate-600 p-1 ${!tdata.geography ? REDBACKGROUND : ""}`}>
              <select
                value={tdata.geography || ""}
                onChange={(e => {
                  updateData(tdata.id, 'geography', e.target.value)
                })}
                className='p-1 rounded '
              >
                <option value={""} disabled>Geography</option>
                {GeographyDropdownValues.map(v => <option value={v} >{v}</option>)}
              </select>
            </td>
            <td className="border border-slate-600 p-1">
              <button className="primary-btn bg-red-600 hover:bg-red-700 active:bg-red-800 rounded-md"
                onClick={(e => {
                  deleteData(tdata.id)
                })}
              >DELETE</button>
            </td>
          </tr >)


          : null
      }
      <tr className="w-full p-2">
        <td className="flex justify-center w-full pt-2"><button onClick={createNew} className="w-40 px-4 py-2 mb-20 bg-slate-600 rounded text-white">Add New</button></td>

      </tr>

    </tbody >


  </table >
}

export default SimilarProductsTabular;
